import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

import {onMounted, reactive, ref, UnwrapRef} from "vue";
import DentistTeamForm from "@/views/team/form.vue"
import {searchDentistTeam} from "@/api/dentist_team"
import router from "@/router";
import {groupDentistReviewStatus} from "@/api/doctor";
import {LocalStorageService} from "@/components/ts/localStorage";
import {USER_INFO} from "@/store/mutation-types";

interface Data {
    dentistTeamId: number,
    dentistTeam: any;
    loading: boolean;
    dataSource: any[];
    pagination: any;
    name: string,
    type: number,
    team_form_visible: boolean,
    dentist_form_visible: boolean,
    form_loading: boolean,
    hasNone: number,
    notPass: number,
    hasPass: number,
}



export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {


const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        width: 80,
        customRender: ({index}: any) => `${index + 1}`,
    },
    {
        title: "资料",
        children: [
            {
                title: "名称",
                dataIndex: "name",
                key: "name",
                width: 200,
                customRender: ({record}: any) => `${record.name}`,
            },
            {
                title: "负责人",
                dataIndex: "principal",
                key: "principal",
                width: 200,
                customRender: ({record}: any) => `${record.principal ? record.principal.name : ''}`,
            },
            {
                title: "成员",
                dataIndex: "members",
                key: "comment",
            },
        ]
    },
    {
        title: "业绩",
        children: [
            {
                title: "客户",
                dataIndex: "patientCnt",
                key: "patientCnt",
                width: 80,
            },
            {
                title: "订单",
                dataIndex: "orderCnt",
                key: "orderCnt",
                width: 80,
            },
        ]
    },
    {
        title: "操作",
        dataIndex: "operation",
        width: "15%"
    },
];

let data: UnwrapRef<Data> = reactive({
    loading: true,
    dentistTeam: null,
    dataSource: [],
    dentistTeamId: -1,
    name: "",
    comments: "",
    members: "",
    team_form_visible: false,
    dentist_form_visible: false,
    form_loading: false,
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: true,
        showSizeChanger: true,
    },
    type: 0,
    hasNone: 0,
    notPass: 0,
    hasPass: 0,
});


const init = () => {
    searchByReviewStatus();
    search();
}
const onDepartment = (id: number) => {
    router.push({
        path: '/organization/department',
        query: {
            id: id,
            type: "dentist_team",
        }
    })
}

const onScheduling = (id: number) => {
    router.push({
        path: '/dentist/team/scheduling',
        query: {
            relatedId: id,
            relateType: 16
        }
    })
}

const refDentistTeamForm = ref()
const tagColor = (item: any) => {
    if (item.reviewStatus === "HAS_NONE") {
        return 'grey'
    } else if (item.reviewStatus === "NOT_PASS") {
        return 'red'
    } else {
        return 'cyan'
    }
}
const submitDentistTeamForm = () => {
    refDentistTeamForm.value.onSubmit();
};

const editDentistTeam = (record: any) => {
    // console.log(record);
    data.team_form_visible = true
    data.dentistTeamId = record.id;
    data.dentistTeam = record;
    data.type = 1
};

// const getMemberNames = (members: any) => {
//   let tmp: any[] = [];
//   members.forEach((x: any) => tmp.push(x.person.firstName));
//   return tmp;
// }

const hideForm = () => {
    data.team_form_visible = false;
};


const onCancel = () => {
    data.team_form_visible = false;
    search();
};

const onSearchFormFinish = () => {
    data.pagination.current = 1;
    search();
};

const searchFormState = reactive({
    keyword: "",
    type: 1,
    reviewStatus: null
});
const searchForStatus = (reviewStatus: any)=>{
    data.pagination.current = 1;
    searchFormState.reviewStatus = reviewStatus;
    search();
}
const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    search();
};
const search = () => {
    data.loading = true
    searchDentistTeam(
        {
            page: {
                pageSize: data.pagination.pageSize,
                currPage: data.pagination.current,
            },
            keyword: searchFormState.keyword,
            reviewStatus: searchFormState.reviewStatus
        }
    ).then((res: any | null) => {
        data.loading = false;
        // console.log(res)
        data.loading = false;
        data.dataSource = res ? res.data : [];
        data.pagination.total = res ? res.records : 0;
    });
}


const createDentistTeam = () => {
    data.type = 0
    data.dentistTeamId = 0;
    data.team_form_visible = true
};

const searchByReviewStatus = () => {
    groupDentistReviewStatus().then((res: any) => {
        data.hasNone = res.hasNone
        data.notPass = res.notPass
        data.hasPass = res.hasPass
    })
}

onMounted(() => {
    init();
})


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_btnPermission = _resolveDirective("btnPermission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      name: "advanced_search",
      class: "ant-advanced-search-form",
      onFinish: onSearchFormFinish,
      model: searchFormState
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: searchFormState.keyword,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFormState.keyword) = $event)),
                      placeholder: "关键字",
                      "allow-clear": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  style: {"margin":"0 8px"},
                  onClick: createDentistTeam
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_btnPermission, 'team:add']
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (_unref(data).hasNone > 0 ||_unref(data).notPass > 0|| _unref(data).hasPass > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createTextVNode(" 全部临床医生："),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (searchForStatus(null)))
          }, _toDisplayString(Number.parseInt(_unref(data).hasNone)+Number.parseInt(_unref(data).notPass)+Number.parseInt(_unref(data).hasPass)), 1),
          _createTextVNode("    待审核："),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (searchForStatus(0)))
          }, _toDisplayString(_unref(data).hasNone), 1),
          _createTextVNode("    未通过："),
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (searchForStatus(1)))
          }, _toDisplayString(_unref(data).notPass), 1),
          _createTextVNode("    已审核："),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (searchForStatus(2)))
          }, _toDisplayString(_unref(data).hasPass), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_table, {
      bordered: "",
      dataSource: _unref(data).dataSource,
      columns: columns,
      loading: _unref(data).loading,
      pagination: _unref(data).pagination,
      onChange: changePageIndex,
      scroll: { y:400},
      size: "small"
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'principal')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.principal ? record.principal.name : ''), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'members' && record.dentists)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(record.dentists, (item) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                color: tagColor(item),
                key: item.name
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (editDentistTeam(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_btnPermission, 'team:update']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onDepartment(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("职位")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_btnPermission, 'team:update']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onScheduling(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("排班")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_btnPermission, 'team:update']
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"]),
    _createVNode(_component_a_modal, {
      visible: _unref(data).team_form_visible,
      title: "医生团队",
      width: "40%",
      onCancel: hideForm,
      onOk: submitDentistTeamForm
    }, {
      default: _withCtx(() => [
        (_unref(data).team_form_visible)
          ? (_openBlock(), _createBlock(DentistTeamForm, {
              key: 0,
              type: _unref(data).type,
              "dentist-team-id": _unref(data).dentistTeamId,
              "dentist-team": _unref(data).dentistTeam,
              ref_key: "refDentistTeamForm",
              ref: refDentistTeamForm,
              onOnCancel: onCancel
            }, null, 8, ["type", "dentist-team-id", "dentist-team"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})